import { getEventServiceSDK } from '@/sdk/getEventServiceSDK';

interface IdentifyProps {
  trigger: 'app_launch' | 'user_info_update' | 'mvpd_auth' | 'register' | 'login' | 'logout';
  dma: BigInt;
}

export async function triggerIdentifyEvent(params: IdentifyProps): Promise<Foxkit.EventService.EventServiceResponse> {
  const { trigger, dma } = params;

  const eventService = await getEventServiceSDK();

  return eventService.logEvent({
    eventData: {
      event_name: 'identify',

      properties: {
        identify_trigger: trigger,
        advertising_id: '',
        manufacturer_id: '',
        dma,
      },
    } as Foxkit.EventService.IdentifyEvent,
  });
}
